import Card from "./Card";

export default function Board({ cards = [] }) {
  return (
    <div className="Board">
      {[0, 1, 2, 3, 4].map((i) =>
        cards[i] ? (
          <Card card={cards[i]} key={i} />
        ) : (
          <div className="Blank" key={i} />
        )
      )}
    </div>
  );
}
